import {
    COMPARADOR_LOAD_YEARS_BEGIN,
    COMPARADOR_LOAD_YEARS_FAILURE,
    COMPARADOR_LOAD_YEARS_SUCCESS
} from './constants'
import axios from 'axios'

export function loadYears(endpoint, inputValue, index) {
    return (dispatch) => {
        if (!endpoint || index === undefined) {
            return null
        }

        dispatch({ type: COMPARADOR_LOAD_YEARS_BEGIN })

        return new Promise((resolve, reject) => {
            const doRequest = axios.get(endpoint)
            doRequest.then(
                (res) => {
                    const responseData = getResponseYearsMapped(res.data.data)
                    dispatch({
                        type: COMPARADOR_LOAD_YEARS_SUCCESS,
                        data: responseData,
                        index: index
                    })

                    let aux = res.data.data.filter((dataValue) => dataValue.year.toString().includes(inputValue.toUpperCase()))
                    resolve(getResponseYearsMapped(aux))
                },
                (err) => {
                    dispatch({
                        type: COMPARADOR_LOAD_YEARS_FAILURE,
                        data: { error: err },
                        index: index
                    })
                    reject(err)
                }
            )
        })
    }
}

const getResponseYearsMapped = (val) => {
    return val.map((item) => ({
        label: item.year,
        value: item.year,
        id: item.year
    }))
}

export function reducer(state, action) {
    const { index, data, type } = action
    if (index === undefined) return state
    switch (type) {
        case COMPARADOR_LOAD_YEARS_BEGIN:
            return {
                ...state,
                models: {
                    ...state.models,
                    [`${index}`]: {
                        isPending: true,
                        hasError: null,
                        data: null
                    }
                }
            }

        case COMPARADOR_LOAD_YEARS_SUCCESS:
            return {
                ...state,
                models: {
                    ...state.models,
                    [`${index}`]: {
                        isPending: false,
                        hasError: null,
                        data: data
                    }
                }
            }

        case COMPARADOR_LOAD_YEARS_FAILURE:
            return {
                ...state,
                models: {
                    ...state.models,
                    [`${index}`]: {
                        isPending: false,
                        hasError: data.error,
                        data: null
                    }
                }
            }
        default:
            return state
    }
}

